export const StateNames = {
  shop_v3: 'shop_v3',
  app_v4: 'app_v4',
  auth_v3: 'auth_v3',
  map_v6: 'map_v6',
} as const;

export type StateNames = (typeof StateNames)[keyof typeof StateNames];
